import React, {createContext, useCallback, useContext, useMemo} from 'react';
import {getSuspenseRef} from '../utils/references/suspenseRef.js';
import {RefCollectContext} from "../contexts/RefCollectContext.jsx";

export const HotelLookupContext = createContext(null);

const HotelLookupProvider = ({ children }) => {
  const refCollectorCtx = useContext(RefCollectContext);

  const getHotel = useCallback((hotelId) => {
    return getSuspenseRef('hotel', hotelId, refCollectorCtx);
  }, [refCollectorCtx]);

  const value = useMemo(() => ({
    getHotel,
  }), [
    getHotel,
  ]);

  return (
    <HotelLookupContext.Provider value={value}>
      {children}
    </HotelLookupContext.Provider>
  );
};

export const useHotelLookup = () => {
  const context = useContext(HotelLookupContext);
  if (!context) {
    throw new Error('useHotelLookup must be used within a HotelLookupProvider');
  }
  return context;
};

export default HotelLookupProvider;
